import React, {useState} from "react";
import authAxios from "../api/axios";
import { fnFetchAllSubject, fnModifyAsyncRedirect, fnModifyAsyncNoRedirect, fnFetchSubjectID, fnDeleteSubjectIDNoRedirect, fnPostToSubject } from './CrudContextProviderUtil';
export const PartDataContext = React.createContext();

export default function PartDataProvider(props) {
    const [isLoading, setIsLoading] = useState(false);
    return (
        <PartDataContext.Provider value={ 
            {
                modifyPartAsync: fnModifyAsyncRedirect(authAxios, "part", function(){}, setIsLoading),
                modifyPartAsyncNoRedirect: fnModifyAsyncNoRedirect(authAxios, "part", function(){}, setIsLoading),
                fetchAllPartAsync: fnFetchAllSubject(authAxios, "part", function(){}, setIsLoading),
                fetchPartAsync: fnFetchSubjectID(authAxios, "part", function(){}, setIsLoading),
                postNewPart: fnPostToSubject(authAxios, "part", function(){}, setIsLoading),
                deletePartAsync: fnDeleteSubjectIDNoRedirect(authAxios, "part", function(){}, setIsLoading),
                isLoading,
            } }>
            { props.children }
        </PartDataContext.Provider>
    )
}
